import { ColorSpot1, Spacing4 } from 'autogen/design-tokens/tokens';
import Price from 'components/generic/productPrice/components/Price';
import { PriceDiscount } from 'components/generic/productPrice/components/PriceDiscount';
import type { IPrice } from 'components/generic/productPrice/components/shared/types';
import React from 'react';
import styled, { css } from 'styled-components';

const StyledPrice = styled(Price)<{ isOnDiscount?: boolean }>`
    ${({ isOnDiscount }) =>
        isOnDiscount &&
        css`
            color: ${ColorSpot1};
        `}
`;

const PriceContainer = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    column-gap: ${Spacing4};
    align-items: flex-end;
`;

const Container = styled.span`
    display: inline-flex;
    flex-direction: column;
`;

interface IProductPrice extends IPrice {
    isOnDiscount?: boolean;
    priceBefore?: string;
    priceSaving?: string;
    priceTitle?: JSX.Element;
}

export default function ProductPrice({
    price,
    priceBefore,
    priceSaving,
    isOnDiscount,
    size,
    priceTitle,
    ...restProps
}: IProductPrice) {
    return (
        <Container {...restProps}>
            {priceTitle}
            <PriceContainer>
                <StyledPrice price={price} size={size} isOnDiscount={isOnDiscount} />
                {isOnDiscount && priceBefore && (
                    <PriceDiscount price={priceBefore} priceSaving={priceSaving} size={12} />
                )}
            </PriceContainer>
        </Container>
    );
}
